import { Component } from '@angular/core';
import { DatePipe } from "@angular/common";
import { RouterOutlet } from '@angular/router';
import { NgFor } from "@angular/common";
import { NgClass } from "@angular/common";
import { Observable, of } from 'rxjs';


import { Schedule } from '../../objects/schedule';
import { ScheduleFilter } from '../../objects/schedulefilter';

import { MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { MatIconModule } from '@angular/material/icon';
import { DataSource } from '@angular/cdk/collections';
import { ScheduleDataService } from '../../services/schedule-data-service';


import { NgIf } from "@angular/common";


import { MatListModule } from '@angular/material/list';

import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { prepareUpdateSchedule } from '../../objects/programmatieblok';
import { MY_FORMATS } from '../mydateformat';



/**
 * @title Basic use of the tab group
 */
@Component({
  selector: 'schedule-component',
  templateUrl: './schedule-component.html',
  styleUrls: ['./schedule-component.css'],
  standalone: true,
  imports: [NgFor, NgIf, NgClass, MatDialogModule, MatButtonModule, MatDialogTitle, MatDialogContent, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, FormsModule, MatTableModule, DatePipe, MatDatepickerModule],
  providers: [provideMomentDateAdapter(MY_FORMATS)]
})
export class ScheduleComponent {

  schedulefilter: ScheduleFilter = {
    startlistdate: null, // or initialize with any default value
    collectionName: "",
    startdate: "",
    enddate: "",
    overlapFlag: "1"
    // other properties initialization if needed
  };

  schedule: Schedule;  // URL to web api

  constructor(private scheduleDataService: ScheduleDataService) { }

  ngOnInit(): void {
    // Subscribe to the observable returned by getSchedule()
    this.scheduleDataService.getSchedule(this.schedulefilter).subscribe((schedule: Schedule) => {
      this.schedule = schedule; // Assign the value to this.schedule when it emits
    });
  }

scheduleClicked(data) {
  if (data && data.programmatieblok && data.programmatieblok.linkURL) {
    const linkURL = data.programmatieblok.linkURL;
    //this.router.navigateByUrl(linkURL); // or this.router.navigate([linkURL]);
    window.location.href = linkURL;
  }
} 


nextWeek(data) {
  this.schedulefilter.startlistdate = data.programmatielijn.navigatie.navigatieblok.nextweekmondaystr;
    this.getWeek(this.schedulefilter);
}

prevWeek(data) {
  this.schedulefilter.startlistdate = data.programmatielijn.navigatie.navigatieblok.prevweekmondaystr;
    this.getWeek(this.schedulefilter);
}

getWeek(data) {
  this.scheduleDataService.getSchedule(this.schedulefilter).subscribe((schedule: Schedule) => {
    this.schedule = schedule; // Assign the value to this.schedule when it emits
  });
}





}
